interface ScanEvent {
  timestamp: number;
  type: "success" | "invalid" | "timeout" | "error";
  barcode?: string;
  reason?: string;
}

const KEY = "scan_analytics";

export function logScanEvent(event: ScanEvent) {
  try {
    const existing = JSON.parse(localStorage.getItem(KEY) || "[]");
    existing.push(event);
    localStorage.setItem(KEY, JSON.stringify(existing));
  } catch (err) {
    console.debug("Analytics logging failed", err);
  }
}

export function getScanStats() {
  try {
    const events: ScanEvent[] = JSON.parse(localStorage.getItem(KEY) || "[]");
    return {
      total: events.length,
      success: events.filter(e => e.type === "success").length,
      invalid: events.filter(e => e.type === "invalid").length,
    };
  } catch {
    return { total: 0, success: 0, invalid: 0 };
  }
}
